module.exports = __webpack_public_path__ + "assets/images/office_photo.f7d7ec482eba7b93bfc4f30400027b9a.png";